export const FAVORITE_PRODUCTS = 'favorite_products'
